/* eslint-disable react/no-unused-prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-children-prop */
import { Container, Divider, Flex, Heading } from "@chakra-ui/react";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import { NextSeo } from "next-seo";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import style from "../../styles/markdown.module.css";
import IntercomHelp from "../IntercomHelp";
import Banner from "lib/components/home/Banner";

import HelpBreadcrumb from "./HelpBreadcrumb";
import HelpHeader from "./HelpHeader";

// Hoisted to module scope — avoids recreating the renderer object on every render.
// The custom h1→h2 remap is a plain function reference, safe to define once.
const helpMarkdownComponents = ChakraUIRenderer({
  // Remap markdown # (h1) to render as h2 — the article title
  // is already an h1 in HelpHeader, so section headings must be h2.
  // eslint-disable-next-line react/no-unstable-nested-components
  h1: ({ children, ...props }) => (
    <Heading as="h2" size="xl" {...props}>
      {children}
    </Heading>
  ),
});

export interface HelpPostProps {
  title: string;
  description: string;
  content: string;
  date_created: string;
  date_updated: string;
  slug: string;
  Category?: string;
}

export default function Help({ title, description, content }: HelpPostProps) {
  return (
    <>
      <NextSeo title={title} description={description} />
      <Banner />

      <HelpBreadcrumb title={title} />

      <HelpHeader title={title} />
      <Container maxW="5xl" px={10}>
        <Divider />
      </Container>
      <Container maxW="5xl" py={{ base: 10, md: 14 }} px={14}>
        <Flex
          align="center"
          justify="flex-start"
          wrap="wrap"
          m={1}
          direction="column"
        >
          <ReactMarkdown
            components={helpMarkdownComponents}
            className={style.reactMarkDown}
            remarkPlugins={[remarkGfm]}
            children={content}
            skipHtml
          />
        </Flex>
      </Container>
      <IntercomHelp />
    </>
  );
}
